'use strict';
// https://github.com/tc39/proposal-array-find-from-last/
require('../modules/esnext.array.find-last');
require('../modules/esnext.array.find-last-index');
require('../modules/esnext.typed-array.find-last');
require('../modules/esnext.typed-array.find-last-index');
